// IMPORTS
import _ from 'lodash'
import axios from 'axios'
import mobiscroll from '@mobiscroll/javascript'
import swal from 'sweetalert'

// DEFINITIONS
const cartAPI = 'cart/process'

const emptyConfigs = {
    shipping: null,
    shipping_cost: null,
    address: null,
    usuarios_domicilios_id: null
}

let addressArchetype = {
    calle: null,
    numero: null,
    numero_interior: null,
    colonia: null,
    municipios_id: null,
    estados_id: null,
    codigo_postal: null,
    referencia: null,
    envio: 0,
}

const state = {
	cart: [], // almacena los ids de los productos
    cartConfigs: _.clone(emptyConfigs),
    total: 0.0,  // almacena el total de los productos,
    addressArchetype: _.clone(addressArchetype), // Address Archetype
    // addressIsValid: false
}

const getters = {
    cartGetAddressIsValid: (state) => {
        console.debug("_.isArray(state.cart)", _.isArray(state.cart))
        console.debug("state.cart.length", state.cart.length)
        console.debug("!_.isNaN(parseInt(state.cartConfigs.usuarios_domicilios_id))", !_.isNaN(parseInt(state.cartConfigs.usuarios_domicilios_id)))
        return (_.isArray(state.cart) && state.cart.length && !_.isNaN(parseInt(state.cartConfigs.usuarios_domicilios_id)))
    },
    cartGetConfigs: (state) => {return state.cartConfigs },
    cartGetItems: (state) => {return state.cart },
    cartGetTotal: (state) => {return state.total },
    cartGetAddress: (state) => {return state.addressArchetype },
}

const mutations = {
	cartSet: (state, payload) => {
        state.cart              = []; 
        state.cart              = payload;
        state.cartConfigs       = _.clone(emptyConfigs)
    },
	cartSetTotal: (state, payload) => {state.total = payload},
	cartSetConfigs: (state, payload) => {state.cartConfigs = payload},
    cartSetFromLocal: (state, payload) => {
        _.forEach(payload, (a, b) => {
            state[b] = a
        })
    },
    // cartSetValidAddress: (state, payload) => {
    //     state.addressIsValid = payload
    // }
}

const actions = {
    cartAddNewAddresData: async ({getters, commit}) => {
        try {
            const data2post = getters.cartGetAddress
            const response = await axios.post('cart/addnewaddress', data2post)

            // VALIDTION
            // if(response.status){
            //     commit('cartSetValidAddress', true)
            // }

            // ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
            if (response.msg) {
                mobiscroll.snackbar({
                    display: 'top',
                    theme: 'ios',
                    message: response.msg,
                    color: response.class,
                    duration: 7000
                })
            }
            return response
        } catch(e){
            console.error(e)
        }
    },
    cartRemoveProductByIndexInCart: ({getters, commit, dispatch}, payload) => {
        let currentCart = _.clone(getters.cartGetItems)
        currentCart.splice(payload, 1)
        commit('cartSet', currentCart)
        dispatch('cartTotalize')
    },
	cartAddItem: ({getters, commit, dispatch}, payload) => {
        let currentCart = _.clone(getters.cartGetItems)
        currentCart.push(payload)
        commit('cartSet', currentCart)
        dispatch('cartTotalize')
    },
	cartTotalize: ({getters, dispatch, commit}) => {
        let currentCart = _.clone(getters.cartGetItems),
            productsIndex = getters.catalogosGetProductos,
            total = 0;
        _.forEach(currentCart, productId => {
            let product = _.find(productsIndex, {id: productId})
            console.log("product", product)
            total += parseFloat(product.precio)
        })
        console.debug(getters.cartGetConfigs)
        if(!!getters.cartGetConfigs.shipping_cost)
            total += getters.cartGetConfigs.shipping_cost;
        commit('cartSetTotal', total)
        dispatch('cartWriteToLocal')
    },
    cartWriteToLocal: ({getters}) => {
        window.localStorage.setItem('cart', JSON.stringify(state))
    },
    cartReadFromLocal: ({getters, commit}) => {
        let recoveredState = window.localStorage.getItem('cart')
        commit('cartSetFromLocal', JSON.parse(recoveredState))
    },
    // TO INCLUDE
    cartUpdateConfigs: ({commit, dispatch}, payload) => {
        commit('cartSetConfigs', {
            shipping: payload.shipping,
            shipping_cost: payload.shipping_cost,
            address: payload.address,
            usuarios_domicilios_id: payload.usuarios_domicilios_id
        })
        // dispatch('cartTocartUpdateConfigstalize')
    },
    cartClean: async ({commit, dispatch}) => {
        commit('cartSet', [])
        dispatch('cartTotalize')
    },
    cartProcess: async ({dispatch, getters}, payload) => {
        try {
            let items       = getters.cartGetItems, 
                configs     = getters.cartGetConfigs,
                data2send   = {items, configs};

            // OPENPAY ID (payload)
            data2send.openpay = payload;

            // RESPONSE AWAIT
            let response        = await axios.post(cartAPI, data2send);

            // EN CASO DE QUE HAYA SALIDO TODO BIEN, SIMPLEMENTE LIMPIA EL CARRITO... HAPPY LIFE!
            if(response.status){
                dispatch('cartClean');
            }

            // ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
            if (response.msg && !response.status) {
                mobiscroll.snackbar({
                    display: 'top',
                    theme: 'ios',
                    message: response.msg,
                    color: response.class,
                    duration: 7000
                })
            } 
            
            else if(response.status && response._charge.data.type == 'normal'){
                swal({
                    icon: response.class,
                    title: response.msg
                })
                return response.status
            }
            
            else if(response.status && response._charge.data.type == 'redirect'){
                await swal({
                    icon: response._charge.class,
                    title: response._charge.msg
                })
                window.document.location.href = response._charge.data.url
                // console.log("response._charge", response._charge)
                return false; // DEVUELVE FALSO PARA EVITAR LA REDIRECCIÓN
            }

        } catch (e) {
            console.error(e)
            mobiscroll.snackbar({
                display: 'top',
                theme: 'ios',
                message: 'Ocurrió un error obteniendo la respuesta: ' + e,
                color: 'warning',
                duration: 7000
            })
            return false;
        }
    }
}

// EXPORTS
export default {
	state,
	getters,
	mutations,
	actions
}